module.exports = __webpack_public_path__ + "img/capa2.e6586cc0.jpg";